/**
 * Hero Slider.
 *
 * Swipe/Drag Functionality still a little raw but working.
 */
(function ($) {
	const arriveOptions = {
		onceOnly: true, // ensure that registered callbacks fire only once
		existing: true, // ensure that the registered callback is fired for the elements that already exist in the DOM and match the selector
	};
	let heroSlider = ".hero-slider";
	let fullBleedBanner = ".wp-block-cd-full-bleed-banner";
	let cycleSpeed = 8500;
	let initialized = false;
	let cycleActive = true;
	let slideTransitionTime = 750;

	let $heroSliders = $(heroSlider);

	function initBanners() {
		initialized = true;
		$heroSliders.each(function () {
			$(this).attr("tabindex", 0);
			let slides = $(this).find(fullBleedBanner);
			let numSlides = slides.length;

			if (numSlides > 0) {
				let $startSlide = $(slides[0]);
				$startSlide.css("display", "block");
				$startSlide.addClass("is-active");
				if (numSlides > 1) {
					setInterval(function () {
						if (cycleActive) advanceBanners(slides, true);
					}, cycleSpeed);
				}
			}
		});
	}

	/**
	 * Progresses hero slider banner
	 *
	 * @param {Obj}     banners     array of slide objects
	 * @param {boolean} isForward   true if slider should go forward
	 */
	function advanceBanners(banners, isForward) {
		let numBanners = banners.length;
		let firstBanner = banners[0];
		let lastBanner = banners[numBanners - 1];

		let currentBannerIndex = 0;
		for (let i = 0; i < numBanners; i++) {
			let $currBanner = $(banners[i]);
			if ($currBanner.hasClass("is-active")) {
				currentBannerIndex = i;
				break;
			}
		}

		let $currentBanner = $(banners[currentBannerIndex]);
		let $nextBanner = "";
		let isRepeat = true;
		if (isForward) {
			isRepeat = currentBannerIndex === numBanners - 1;
			if (isRepeat) {
				$currentBanner = $(lastBanner);
				$nextBanner = $(firstBanner);
			} else {
				$nextBanner = $(banners[currentBannerIndex + 1]);
			}
		} else {
			isRepeat = currentBannerIndex === 0;

			if (isRepeat) {
				$currentBanner = $(firstBanner);
				$nextBanner = $(banners[numBanners - 1]);
			} else {
				$nextBanner = $(banners[currentBannerIndex - 1]);
			}
		}

		$currentBanner.removeClass("is-active");
		setTimeout(function () {
			$currentBanner.css("display", "none");
		}, slideTransitionTime + 10);

		$nextBanner.css("display", "block");
		setTimeout(function () {
			$nextBanner.addClass("is-active");
		}, 10);
	}

	function heroSliderKeydown($slider, event) {
		let $slides = $slider.find(fullBleedBanner);
		switch (event.keyCode) {
			case 37:
				advanceBanners($slides, false);
				break;
			case 39:
				advanceBanners($slides, true);
				break;
		}
	}

	$(document).arrive(heroSlider, arriveOptions, function () {
		initBanners();
	});

	$(document).on("ready", function () {
		if (!initialized) initBanners(); // Fallback if arrive fails
	});

	let xDown = null;
	let yDown = null;

	let isDragging = false;
	let xDrag = null;
	let yDrag = null;

	function getTouches(evt) {
		return (
			evt.touches || // browser API
			evt.originalEvent.touches
		); // jQuery
	}
	$heroSliders.on({
		touchstart: function (evt) {
			const firstTouch = getTouches(evt)[0];
			xDown = firstTouch.clientX;
			yDown = firstTouch.clientY;
		},
		touchmove: function (evt) {
			if (!xDown || !yDown) {
				return;
			}

			let slides = $(this).find(fullBleedBanner);

			var xUp = evt.touches[0].clientX;

			var xDiff = xDown - xUp;

			if (xDiff > 0) {
				// left swipe
				advanceBanners(slides, false);
			} else {
				// right swipe
				advanceBanners(slides, true);
			}

			// reset values
			xDown = null;
			yDown = null;
		},
		mousemove: function (event) {
			isDragging = true;
		},
		mousedown: function (event) {
			isDragging = false;
			xDrag = event.pageX;
			yDrag = event.pageY;
			$(this).addClass("is-grabbing");
		},
		mouseup: function (event) {
			if (!xDrag || !yDrag) {
				return;
			}
			let wasDragging = isDragging;

			if (wasDragging) {
				let slides = $(this).find(fullBleedBanner);

				let xUp = event.clientX;

				let xDiff = xDrag - xUp;

				let isThresholdMet = Math.abs(xDiff) > 100;
				if (isThresholdMet) {
					if (xDiff > 0) {
						// left swipe
						advanceBanners(slides, false);
					} else {
						// right swipe
						advanceBanners(slides, true);
					}
				}
			}

			// reset values
			xDown = null;
			yDown = null;
			isDragging = false;
			$(this).removeClass("is-grabbing");
		},
		focus: function () {
			cycleActive = false;
		},
		blur: function () {
			cycleActive = true;
		},
		keydown: function (event) {
			heroSliderKeydown($(this), event);
		},
	});
})(jQuery);
